import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import ButtonBase from "@material-ui/core/ButtonBase";
import Fade from '@material-ui/core/Fade';
import LinearProgress from "@material-ui/core/LinearProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import InboxIcon from '@material-ui/icons/Inbox';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SpeedIcon from '@material-ui/icons/Speed';
import MenuIcon from '@material-ui/icons/Menu';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import Auth from '@aws-amplify/auth';

import { actionTypes } from '../constants';

const Alert = (props) => (<MuiAlert elevation={6} variant="filled" {...props} />);


class AppNavigationContainer extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
            menuOpen: true
        }
    }

    render() {
        let menuClasses = this.state.menuOpen ? 'menu-open' : 'menu-closed';
        let MenuIconComponent = this.state.menuOpen ? MenuOpenIcon : MenuIcon;

        return (
            <div className="wrapper">
                <div className={`wrapper-left ${menuClasses}`}>
                    <div className="logo">
                        <img alt="eXmarX" src="/dist/assets/img/exmarx-logo.png"/>
                    </div>
                    <div className="nav-left">
                        <div className="nav-header">
                            Office Administration
                        </div>
                        <NavLink exact={false} activeClassName='is-active' to="/app/dashboard">
                            <ButtonBase className="nav-item">
                                <div className="nav-item-icon">
                                    <SpeedIcon/>
                                </div>
                                <div className="nav-item-label">
                                    Dashboard
                                </div>
                            </ButtonBase>
                        </NavLink>
                        <NavLink exact={false} activeClassName='is-active' to="/app/departments">
                            <ButtonBase className="nav-item">
                                <div className="nav-item-icon">
                                    <AccountBalanceIcon/>
                                </div>
                                <div className="nav-item-label">
                                    Clients
                                </div>
                            </ButtonBase>
                        </NavLink>
                        <NavLink exact={false} activeClassName='is-active' to="/app/reports">
                            <ButtonBase className="nav-item">
                                <div className="nav-item-icon">
                                    <InboxIcon/>
                                </div>
                                <div className="nav-item-label">
                                    Reports
                                </div>
                            </ButtonBase>
                        </NavLink>
                        {__STAGE__ === 'production' ? null : (
                        <NavLink exact={false} activeClassName='is-active' to="/app/state-data">
                            <ButtonBase className="nav-item">
                                <div className="nav-item-icon">
                                    <NotListedLocationIcon/>
                                </div>
                                <div className="nav-item-label">
                                    State Data
                                </div>
                            </ButtonBase>
                        </NavLink>
                        )}
                    </div>
                </div>
                <div className={`wrapper-right ${menuClasses}`} style={{position: 'relative'}}>
                    <div className="nav-top">
                        <div className="nav-hamburger" onClick={()=>{this.setState({menuOpen: !this.state.menuOpen})}}>
                            <Fab>
                                <MenuIconComponent/>
                            </Fab>
                        </div>
                        <div className="nav-actions">
                            <div className="button button-primary" onClick={Auth.signOut.bind(Auth)} style={{height: '36px'}}>
                                Logout
                            </div>
                        </div>
                    </div>
                    <div style={{position: 'absolute', zIndex: 9999, width: '100%'}}>
                        {this.props.progress.is_spinning && <LinearProgress/>}
                    </div>
                    <div className="page">
                        {this.props.progress.snackbar && (
                            <Snackbar
                                open={true}
                                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                autoHideDuration={7000}
                                onClose={this.props.dispatch.bind(this, {type: actionTypes.SNACKBAR_CLEAR})}
                            >
                                <Fade in={this.props.progress.snackbar}>
                                    <Alert onClose={this.props.dispatch.bind(this, {type: actionTypes.SNACKBAR_CLEAR})} severity={this.props.progress.snackbar.severity}>
                                        {this.props.progress.snackbar.text}
                                    </Alert>
                                </Fade>
                            </Snackbar>
                        )}
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}



import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            user: state.user,
            progress: state.progress
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(AppNavigationContainer);